import { JWMButton } from "@components/JWMButton/JWMButton";
import { CMSBlock } from "@jwm/types/CMSBlock";
import { mapButtonProps } from "@utils/cms-mapper/mapButtonProps";
import React from "react";

import style from "../style.module.scss";

interface ButtonBlockProps {
    content: CMSBlock["button"];
    placement?: string;
    fullWidth?: boolean;
}

export const ButtonBlock = ({ content, placement, fullWidth }: ButtonBlockProps): JSX.Element => {
    const buttonProps = mapButtonProps(content);

    const newButtonProps = {
        variant: buttonProps?.buttonProps.variant,
        color: buttonProps?.buttonProps.color,
    };

    return (
        <div className={style.button__adjacent}>
            <JWMButton
                fullWidth={fullWidth}
                buttonProps={newButtonProps}
                disableLink={false}
                text={buttonProps?.text}
                url={buttonProps?.link?.url}
                external={buttonProps?.link?.external}
                url_prefix={buttonProps?.link?.url_prefix}
                anchor_id={buttonProps?.link?.anchor_id}
                serviceLink={buttonProps.serviceLink}
                placement={placement}
            />
        </div>
    );
};
